<template>
  <b-card class="card-location">
    <div class="order-track">
      <div class="order-track-step">
        <div class="order-track-status">
          <span class="order-track-status-dot"></span>
          <span class="order-track-status-line"></span>
        </div>
        <div class="order-track-text flex-fill">
          <b-row>
            <b-col cols="3">
              <h5>ต้นทาง:</h5>
            </b-col>
            <b-col cols="9">
              <div class="text-body-1 text-muted">
                {{
                  item.jobRoutes && item.jobRoutes.length > 0
                    ? item.jobRoutes[0].name
                    : "-"
                }}
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="order-track-step">
        <div class="order-track-status">
          <span class="order-track-status-dot"></span>
          <span class="order-track-status-line"></span>
        </div>
        <div class="order-track-text flex-fill">
          <b-row>
            <b-col cols="3">
              <h5>ปลายทาง:</h5>
            </b-col>
            <b-col cols="9">
              <div class="text-body-1 text-muted">
                {{
                  item.jobRoutes && item.jobRoutes.length > 0
                    ? item.jobRoutes[item.jobRoutes.length - 1].name
                    : "-"
                }}
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <b-button
      @click="$emit('confirmJob', item.id, item.status)"
      :variant="item.status === 'wait' ? 'primary' : 'outline-primary'"
      :class="{ 'btn-gradient-primary': item.status === 'wait' }"
      block>
      {{ item.status === "wait" ? "เริ่มงาน" : "รายละเอียด" }}
    </b-button>
  </b-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
    },
  },
};
</script>
